<div class="content-info">
    <div class="content-title d-flex justify-content-between align-items-center">
        <h3 class="title mb-0">Locations List</h3>
        <div class="d-flex align-items-center gap-2">
            <div class="form-group mb-0" style="min-width: 250px;">
                <div class="input-group">
                    <span class="input-group-text bg-white border-end-0">
                        <i class="bi bi-search text-muted"></i>
                    </span>
                    <input type="text" [(ngModel)]="searchTerm" (input)="onSearch()"
                        placeholder="Search by name or type..." class="form-control border-start-0" />
                </div>
            </div>

            <button class="btn btnprimary text-white text-nowrap" routerLink="/locations/create">
                <i class="bi bi-plus-lg me-1"></i> Add Location
            </button>
        </div>
    </div>

    <div class="common-table mt-4">
        <div class="table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Type</th>
                        <th>Status</th>
                        <th class="text-end">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    @if (locationsLoading) {
                    <tr>
                        <td colspan="4" class="text-center py-5">
                            <div class="spinner-border text-primary" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </td>
                    </tr>
                    } @else {
                    @for (location of locations; track location.id) {
                    <tr>
                        <td>
                            <div class="fw-semibold text-dark">{{ location.name }}</div>
                        </td>
                        <td>
                            <span class="badge bg-light text-dark border">{{ location.type }}</span>
                        </td>
                        <td>
                            <div class="form-check form-switch m-0 d-inline-flex align-items-center">
                                <input class="form-check-input" type="checkbox" [checked]="location.isActive"
                                    (change)="toggleStatus(location)" />
                                <span class="ms-2 small" [class.text-success]="location.isActive"
                                    [class.text-muted]="!location.isActive">
                                    {{ location.isActive ? 'Active' : 'Inactive' }}
                                </span>
                            </div>
                        </td>
                        <td>
                            <div class="d-flex justify-content-end gap-2">
                                <button class="btn btn-sm btn-outline-primary"
                                    [routerLink]="['/locations/edit', location.id]">
                                    <i class="bi bi-pencil"></i>
                                </button>
                                <button class="btn btn-sm btn-outline-danger"
                                    (click)="openDeleteConfirmationModal(confirmDeleteModal, location)">
                                    <i class="bi bi-trash"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    } @empty {
                    <tr>
                        <td colspan="4" class="text-center py-5 text-muted">
                            No locations found.
                        </td>
                    </tr>
                    }
                    }
                </tbody>
            </table>
        </div>

        <!-- Pagination -->
        <div class="table-pagination">
            <div class="pagination-count">
                <select [(ngModel)]="pageSize" (change)="pageSizeChange()">
                    <option [value]="10">10</option>
                    <option [value]="25">25</option>
                    <option [value]="50">50</option>
                    <option [value]="100">100</option>
                </select>
                <span>entries per page</span>
            </div>
            <ul class="pagination">
                <li class="page-item" [class.disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)">
                    <a class="page-link" aria-label="Previous">
                        <span aria-hidden="true">&laquo;</span>
                    </a>
                </li>

                <!-- First Page -->
                <li class="page-item" [class.active]="currentPage === 1" (click)="goToPage(1)">
                    <a class="page-link">1</a>
                </li>

                <!-- Left Ellipsis -->
                @if (currentPage > 4) {
                <li class="page-item disabled">
                    <a class="page-link">...</a>
                </li>
                }

                <!-- Visible Pages -->
                @for (page of getVisiblePages(); track page) {
                <li class="page-item" [class.active]="page === currentPage" (click)="goToPage(page)">
                    <a class="page-link">{{ page }}</a>
                </li>
                }

                <!-- Right Ellipsis -->
                @if (currentPage < pageCount - 3) { <li class="page-item disabled">
                    <a class="page-link">...</a>
                    </li>
                    }

                    <!-- Last Page -->
                    @if (pageCount > 1) {
                    <li class="page-item" [class.active]="currentPage === pageCount" (click)="goToPage(pageCount)">
                        <a class="page-link">{{ pageCount }}</a>
                    </li>
                    }

                    <li class="page-item" [class.disabled]="currentPage === pageCount"
                        (click)="goToPage(currentPage + 1)">
                        <a class="page-link" aria-label="Next">
                            <span aria-hidden="true">&raquo;</span>
                        </a>
                    </li>
            </ul>
        </div>
    </div>
</div>

<!-- Delete Confirmation Modal -->
<ng-template #confirmDeleteModal let-modal>
    <div class="modal-header border-0 pb-0">
        <h5 class="modal-title fw-bold" id="confirmDeleteModalLabel">Confirm Deactivation</h5>
        <button type="button" class="btn-close shadow-none" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body py-4">
        <div class="text-center mb-4">
            <div class="bg-danger bg-opacity-10 text-danger rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                style="width: 64px; height: 64px; font-size: 2rem;">
                <i class="bi bi-exclamation-triangle"></i>
            </div>
            <p class="text-dark mb-1">Are you sure you want to deactivate</p>
            <h5 class="fw-bold">{{ locationToDelete?.name }}?</h5>
            <p class="text-muted small mx-auto" style="max-width: 300px;">
                This action will mark the location as inactive. You can reactivate it later if needed.
            </p>
        </div>
    </div>
    <div class="modal-footer border-0 justify-content-center pb-4 pt-0">
        <button type="button" class="btn border px-4" (click)="modal.dismiss()">Cancel</button>
        <button type="button" class="btn btn-danger px-4" (click)="confirmDelete()">Deactivate</button>
    </div>
</ng-template>